export const reviewTemplate = `<html>
<head>
<style>
body {
  font-family: Arial, sans-serif;
  font-size: 16px;
  margin: 0;
  padding: 20px;
  background-color: #f4f4f4;
  color: #000000;
}
.mainText {
  color: #000000;
}
.container {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0,0,0,.1);
}
.button {
  background-color: #007bff;
  color: #ffffff;
  padding: 10px 20px;
  text-decoration: none;
  border-radius: 5px;
  display: inline-block;
  margin-top: 20px;
  font-weight: bold;
}
.footer {
  font-size: 12px;
  color: #888;
  margin-top: 20px;
}
.logo-container {
  text-align: left;
  margin-bottom: 20px;
}
.logo-container img {
  max-width: 100%;
  height: auto;
  display: block;
  border: 0;
}
</style>
</head>
<body>
  <div class="container">
    <div class="logo-container">
      <img src="https://cdn.prod.website-files.com/67cbee423afbeca3bbd94670/67cfb4dadd9f27851b085f77_Capa_1.png" alt="Business Logo" width="200" height="100" style="object-fit: contain;"/>
    </div>
    <div class="mainText">
    <h2>How was your experience?</h2>
    <p>Hi {{customer-first-name}},</p>
    <p>At {{business-name}}, we're always working to improve our product service, and we need your help to do just that.</p>
    <p>If you have a moment, please leave us a review by clicking below.</p>
    </div>
    <a href="{{buttonUrl}}" class="button" style="color: #ffffff !important;">
      Share feedback
    </a>
    <div class="footer">
      <p>You are receiving this email because you opted in via our website.</p>
      <p>{{businessAddress}}</p>
      <a href="#">Unsubscribe</a>
    </div>
  </div>
</body>
</html>`; 